import { Component, Vue } from 'vue-facing-decorator';
import 
{
    ArrowDown, 
    DataLine, 
    Menu, 
    Checked, 
    OfficeBuilding, 
    GoldMedal, 
    Collection, 
    DocumentChecked, 
    Memo, 
    List,
    User,
    Location,
    ChatLineRound,
    Compass,
    Setting,
    DataAnalysis,
    Suitcase,
    Menu,
    Tickets,
    Box,
    Files
} from '@element-plus/icons-vue';
import { useCookies } from "vue3-cookies";
import NavigationIndex from "@/models/EnumNavigationIndex";
import CookieBanner from '@/components/CookieBanner/CookieBanner.vue';
import AuthService from '@/services/AuthService';

@Component(
{
    props:
    {
        activeMenu: 
        {
            type: String,
            required: false
        },
        windowWidth:
        {
            type: Number,
            required: true
        },
        windowHeight:
        {
            type: Number,
            required: true
        }
    },
    components:
    {
        ArrowDown,
		Menu,
        Checked,
        OfficeBuilding,
        Files,
        DataAnalysis,
        Memo,
        List,
		User,
        Suitcase,
        GoldMedal,
		DocumentChecked,
		Location,
		Setting,
        Compass,
        ChatLineRound,
        Menu,
        Tickets,
        Box,
        Collection,
        CookieBanner
    },
    enums:
    {
        NavigationIndex
    }
})

export default class Navigation extends Vue 
{
    private environmentName = '';
    private environmentVersion = '';
    private breadcrumbs: object[] = [];
    private activeIndex: string = "1";
    private isCollapsed : boolean = true;
    private hasPermission: boolean[] = [] as boolean[];

    public async mounted()
    {
        // get environment version
        this.environmentName = process.env.VUE_APP_ENV;
        this.environmentVersion = process.env.VUE_APP_VERSION;

        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['USER_SELECT'] = AuthService.hasPermission('USER_SELECT');
        this.hasPermission['ROLE_SELECT'] = AuthService.hasPermission('ROLE_SELECT');
        this.hasPermission['TEST_SELECT'] = AuthService.hasPermission('TEST_SELECT');
        this.hasPermission['QSTN_SELECT'] = AuthService.hasPermission('QSTN_SELECT');
        this.hasPermission['REFN_SELECT'] = AuthService.hasPermission('REFN_SELECT');
        this.hasPermission['TARG_SELECT'] = AuthService.hasPermission('TARG_SELECT');
        this.hasPermission['CATG_SELECT'] = AuthService.hasPermission('CATG_SELECT');
        this.hasPermission['CUST_SELECT'] = AuthService.hasPermission('CUST_SELECT');
        this.hasPermission['TKLS_SELECT'] = AuthService.hasPermission('TKLS_SELECT');
        this.hasPermission['SOUR_SELECT'] = AuthService.hasPermission('SOUR_SELECT');
        this.hasPermission['CLNT_SELECT'] = AuthService.hasPermission('CLNT_SELECT');
        this.hasPermission['DASH_CALENDAR'] = AuthService.hasPermission('DASH_CALENDAR');
    }

	public async onMenuClick()
	{
		this.isCollapsed = !this.isCollapsed;
	}

    public handleSelect(key: any, keyPath: any) 
    {
        switch (key)
        {
            case "0":
            case NavigationIndex.DASHBOARD:
                this.activeIndex = "1";
                this.$router.push("/");
                break;

            case NavigationIndex.SOURCE:
                this.$router.push("/source");
                break;

            case NavigationIndex.CUSTOMER:
                this.$router.push("/customer");
                break;
            
            case NavigationIndex.CLIENT:
                this.$router.push("/client");
                break;
            
            case NavigationIndex.CATEGORY:
                this.$router.push("/category");
                break;

            case NavigationIndex.TARGETGROUP:
                this.$router.push("/targetgroup");
                break;

            case NavigationIndex.REFERENCE:
                this.$router.push("/reference");
                break;

            case NavigationIndex.QUESTION:
                this.$router.push("/question");
                break;

            case NavigationIndex.TICKETLIST:
                this.$router.push("/ticketlist");
                break;

            case NavigationIndex.TEST:
                this.$router.push("/test");
                break;

            case NavigationIndex.ROLE:
                this.$router.push("/role");
                break;

            case NavigationIndex.USER:
                this.$router.push("/user");
                break;
        }
    }
}

